export const AuthSortidaEsbarjo = ({ auth, handleChange, error }) => {

  return (<>
    <div className="row">
      <div className="col col-12 ">
        <h4>
          Sortida del recinte a l'hora d'Esbarjo
        </h4>
        <p>
          Entenent que l’escola es troba dins d’un recinte públic i no disposa d’un espai tancat i vigilat, autoritzo
          <br />
          <input type="checkbox" id="authSortidaEsbarjo" name="authSortidaEsbarjo" value={auth} checked={auth === "1" ? true : false} onChange={(t) => { handleChange(t.target.value) }} required />
          <label htmlFor="authSortidaEsbarjo">
            AUTORITZO el meu/va fill/a a sortir del centre a l’hora de l’esbarjo:
          </label>
          <span id="auhtMaterial_ERROR" className="a-Form-error">{error}</span>
        </p>

      </div>
    </div>
  </>)
}
